import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import * as Text from "@/components/text";
import Tippy from "@tippyjs/react";
import useWindowSize from "@/hooks/useWindowSize";
import { motion } from "framer-motion";

const themeObject = {
  text: {
    light: "text-neutral-700",
    dark: "text-white opacity-80",
  },
  divide: {
    light: "divide-x divide-neutra-300",
    dark: "divide-x divide-white opacity-80",
  },
};

const parent = {
  initial: {},
  animate: {
    y: 0,
    opacity: 1,
    duration: 10,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.3,
    },
  },
};
const child = {
  initial: {
    x: -20,
    opacity: 0,
  },
  animate: {
    x: 0,
    opacity: 1,
  },
};
const scaleObject = {
  padding: {
    md: "space-x-3 ",
    sm: "space-x-1.5",
  },
  height: {
    md: "h-[1.25rem]",
    sm: "h-[1.25rem]",
  },
};

export default function Metadata({
  film_metadata = {
    duration: "XX mins",
    year: "202X",
    countries: ["Países"],
    languages: ["idiomas"],
  },
  theme = "light",
  size = "md",
  className,
}) {
  const css = classNames(themeObject.text[theme], className);
  const px = classNames(scaleObject.padding[size]);
  const windowSize = useWindowSize();

  const displayMultipleFields = (dataString) => {
    return (
      <div className="px-1.5 md:px-3">
        <div>
          {windowSize.width > 700 ? (
            <Text.Body
              size={size}
              className={classNames(
                css,
                "divide-white text-ellipsis opacity-80"
              )}
            >
              {dataString.join(", ")}
            </Text.Body>
          ) : dataString.length > 1 ? (
            <>
              <Text.Body
                size={size}
                className={classNames(css, " text-ellipsis capitalize ")}
              >
                {dataString[0]}
              </Text.Body>
              <Text.Body
                className={classNames(
                  css,
                  "divide-white text-ellipsis opacity-80"
                )}
                size={size}
              >
                &nbsp;y {dataString.length - 1} más&nbsp;
              </Text.Body>
            </>
          ) : (
            <>
              <Text.Body
                size={size}
                className={classNames(css, " text-ellipsis capitalize ")}
              >
                {dataString[0]}
              </Text.Body>
            </>
          )}
        </div>
      </div>
    );
  };
  return (
    <>
      <motion.div
        variants={parent}
        initial="initial"
        animate="animate"
        className={classNames(
          scaleObject.height[size],
          themeObject.divide[theme],
          "flex items-center space-x-3 leading-none	 "
        )}
      >
        {film_metadata.duration && (
          <motion.div variants={child} className={classNames(px, "pl-0")}>
            <Text.Body
              size={size}
              className={classNames(css, "whitespace-nowrap ")}
            >
              &nbsp;{film_metadata.duration} mins
            </Text.Body>
          </motion.div>
        )}
        {film_metadata.year && (
          <motion.div variants={child} className={classNames(px)}>
            <Text.Body
              size={size}
              className={classNames(css, film_metadata.duration ? "pl-1" : "")}
            >
              &nbsp;{film_metadata.year}
            </Text.Body>
          </motion.div>
        )}
        {film_metadata.countries && (
          <motion.div variants={child}>
            {displayMultipleFields(film_metadata.countries)}
          </motion.div>
        )}
        {/* {film_metadata.languages && (
          <motion.div variants={child}>
          {displayMultipleFields(film_metadata.languages)}
          </motion.div>
        )} */}
      </motion.div>
    </>
  );
}

Metadata.propTypes = {
  film_metadata: PropTypes.object,
  theme: PropTypes.oneOf(["light", "dark"]),
  size: PropTypes.oneOf(["md", "sm"]),
};
